export const NAV_DRAWER = {
  root: 'nav-drawer',
  body: 'nav-drawer-body',
};
